(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.menuItems = document.querySelector(".header__inline-menu").querySelectorAll("details");
      this.initMenuItems();
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    initMenuItems() {
      if(this.menuItems) {
        this.menuItems.forEach(item => {
          let hoverTimeout;
          let leaveTimeout;
          let isMouseOver = false;

          item.addEventListener("mouseenter", () => {
            // Clear any existing timeouts to prevent unintended behavior
            clearTimeout(hoverTimeout);
            clearTimeout(leaveTimeout);
            isMouseOver = true;

            // Check if any other item is already hovered
            const otherHoveredItem = document.querySelector('.is-hovered');
            if (otherHoveredItem && otherHoveredItem !== item) {
              // Open the new item first after 1 second
              hoverTimeout = setTimeout(() => {
                if (isMouseOver) {
                  item.classList.add('is-hovered');
                  item.setAttribute("open", true);
                  // Close the previously hovered item after the new one is open
                  otherHoveredItem.classList.remove('is-hovered');
                  otherHoveredItem.removeAttribute('open');
                }
              }, 250);
            } else {
              // Open the item after 1 second
              hoverTimeout = setTimeout(() => {
                if (isMouseOver) {
                  item.classList.add('is-hovered');
                  item.setAttribute("open", true);
                }
              }, 250);
            }
          });

          item.addEventListener("mouseleave", () => {
            // Clear the timeout if the mouse leaves before 1 second
            clearTimeout(hoverTimeout);
            isMouseOver = false;

            // Remove the hover class and open attribute after a delay
            leaveTimeout = setTimeout(() => {
              if (!isMouseOver) {
                item.classList.remove('is-hovered');
                item.removeAttribute('open');
              }
            }, 500);
          });
        })
      }
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();

      const stickyJumpLinkNav = document.querySelector('.section--sticky-jump-link-nav');
      if (stickyJumpLinkNav) {
        stickyJumpLinkNav.classList.remove('sticky-header-revealed');
      }
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      const stickyJumpLinkNav = document.querySelector('.section--sticky-jump-link-nav');
      if (stickyJumpLinkNav) {
        if (this.header.classList.contains('scrolled-past-header')) {
          stickyJumpLinkNav.classList.add('sticky-header-revealed');
        } else {
          stickyJumpLinkNav.classList.remove('sticky-header-revealed');
        }
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

      const stickyJumpLinkNav = document.querySelector('.section--sticky-jump-link-nav');
      if (stickyJumpLinkNav) {
        stickyJumpLinkNav.classList.remove('sticky-header-revealed');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Mast (Nov 2026): "Our Stores" dropdown. Click/tap or keyboard opens it;
  // hover opens it on mouse devices; outside click, focus leaving, Escape or scrolling closes it.
  (function () {
    function setOpen(dd, open) {
      if (open) dd.setAttribute('open', '');
      else dd.removeAttribute('open');
      var summary = dd.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeAll(except) {
      document.querySelectorAll('[data-mast-stores-dd][open]').forEach(function (dd) {
        if (dd !== except) setOpen(dd, false);
      });
    }

    document.addEventListener('click', function (event) {
      closeAll(event.target.closest('[data-mast-stores-dd]'));
    });

    document.addEventListener('focusin', function (event) {
      if (!event.target.closest('[data-mast-stores-dd]')) closeAll(null);
    });

    document.addEventListener('keyup', function (event) {
      if (event.key !== 'Escape') return;
      var open = document.querySelector('[data-mast-stores-dd][open]');
      if (!open) return;
      setOpen(open, false);
      open.querySelector('summary').focus();
    });

    window.addEventListener('scroll', function () { closeAll(null); }, { passive: true });

    function bindHover() {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      document.querySelectorAll('[data-mast-stores-dd]').forEach(function (dd) {
        if (dd.__mastHover) return;
        dd.__mastHover = true;
        var leaveTimer;
        var hoverOpened = false;
        dd.addEventListener('mouseenter', function () {
          clearTimeout(leaveTimer);
          if (!dd.hasAttribute('open')) hoverOpened = true;
          setOpen(dd, true);
        });
        dd.addEventListener('mouseleave', function () {
          leaveTimer = setTimeout(function () {
            hoverOpened = false;
            setOpen(dd, false);
          }, 300);
        });
        // A click right after hover-opening keeps the list open instead of toggling it shut.
        dd.querySelector('summary').addEventListener('click', function (event) {
          if (!hoverOpened) return;
          event.preventDefault();
          hoverOpened = false;
          setTimeout(function () { setOpen(dd, true); }, 0);
        });
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindHover);
    else bindHover();
  })();

  } catch(e) { console.error(e); }
})();
})();
